import $ from 'jquery';
import Splide from '@splidejs/splide';

$(document).ready(function () {
	$('.block--carousel-content').each(function () {
		var tabsElem = $(this).find('.tab-carousel-tabs');
		var tabsElemGet = abc.data('lat');
		var contentElem = $(this).find('.tab-carousel-tabs');

		var tabs = new Splide($(this).find('.tab-carousel-tabs'), {
			type: 'loop',
			height: '10rem',
			focus: 'center',
			autoWidth: true,
		});

		var content = new Splide($(this).find('.tab-carousel-content'), {
			type: 'fade',
		});

		//console.log($(this).find('.tab-carousel-tabs'));

		tabs.mount();
		content.mount();
	});
});
